import { StackProps, VStack } from "@chakra-ui/react";
import React from "react";

export const ValueAndButtons = (props: StackProps) => (
  <VStack align="start" gap={2} {...props} />
);
